/* eslint-disable import/order */
/* eslint-disable react-hooks/exhaustive-deps */

import React, { FC, useEffect, useState } from 'react';
import { Modal, Popconfirm, Skeleton, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router';
import { Button, DocumentInput, Form, Space } from '~/components';
import { useUploadSignedContract } from '~/controllers/contract';
import { ContractGenerationIcon, DocuSignLogoIcon } from '~/img';
import Section from '~/layouts/Section ';
import { ImageResponse } from '~/types/files';
import paths from '~/pages/paths';
import { useGetApplication } from '~/controllers/wizard';
import { isReadOnly } from '~/utils/isReadOnly';
import { getEmail } from '~/utils/getDecodedJwt';
import { fetchDocumentFromDocuSign, signWithDocuSign } from '~/api/contract';
import DocumentsSharingProgressModal from './DocumentsSharingProgressModal';
import SignatorySection from './SignatorySection';
import SaveSignedConsent from './SaveSignedConsent';
import SaveConsent from './SaveConsent';
import { useAuthorizedSignatories } from '~/hooks';
import { useCardHolderContext } from '~/controllers/cardHolderContext';
import { useGenerateConsent } from '~/controllers/consent';
import buildNamePath from '~/utils/buildNamePath';
import { useGetCardHolder, useSaveCardHolderDetails } from '~/controllers/cardholder';
import { useMutateContactsApi } from '~/controllers/contacts';
import createUid from '~/utils/createUid';
import { contactObjCreation } from '~/utils/contacts';
import { getCardholderContactId } from '~/api/contacts';

const NonUaePassSignConsent: FC = () => {
  const { t } = useTranslation('cardHolderConsent');
  const applicationQuery = useGetApplication();
  const generateConsentMutation = useGenerateConsent();
  const uploadContractMutation = useUploadSignedContract();
  const location = useLocation();
  const history = useHistory();
  const pathName = useLocation();
  const isItcardholderFlow = pathName?.pathname?.split('/')?.includes('cardHolder');
  const [form] = Form.useForm();

  const { updateCardHolderData, updateStepKey } = useCardHolderContext();

  const { data: cardHolderData } = useGetCardHolder();
  // const isOnboardingCompleted = cardHolderData && cardHolderData?.status === 'RECEIVED_CONSENT';
  const [isOnboardingCompleted, setIsisOnboardingCompleted] = useState(false);

  useEffect(() => {
    setIsisOnboardingCompleted(cardHolderData ? cardHolderData?.status === 'RECEIVED_CONSENT' : false);
  }, [cardHolderData]);
  const contactMutation = useMutateContactsApi();
  useEffect(() => {
    const consent = cardHolderData && cardHolderData?.consent;
    if (consent) {
      form.setFieldsValue({
        consent,
      });
    }
  }, [cardHolderData, form]);

  // useEffect(() => {
  //   console.log('cardHolderDatacardHolderDataxxxx', cardHolderData);
  //
  // }, [cardHolderData]);

  const docuSignSignatureProcessId = applicationQuery.data?.payload.docuSignSignatureProcess?.envelopeId;
  const isSignatureProcessInProgress = !!docuSignSignatureProcessId;

  const [open, setOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSendingToDocuSign, setSendingToDocuSign] = useState(false);
  const [docuSignDocument, setDocuSignDocument] = useState();
  const [isDocuSignError, setDocuSignError] = useState(false);
  const [isContractDeclined, setContractDeclined] = useState(false);

  const [showSignConsent, setShowSignConsent] = useState(false);

  const saveCardHolderMutation = useSaveCardHolderDetails();

  useEffect(() => {
    if (isDocuSignError) {
      Modal.error({
        content: <div style={{ paddingLeft: 40 }}>{t('cardholder.details.consent.failed')}</div>,
        onOk: () => {
          history.go(0);
        },
        centered: true,
        okText: t('Close'),
      });
    }
  }, [isDocuSignError, history, t]);

  useEffect(() => {
    if (isContractDeclined) {
      Modal.warning({
        content: <div style={{ paddingLeft: 40 }}>{t('cardholder.details.consent.declined')}</div>,
        onOk: () => {
          history.go(0);
        },
        centered: true,
        okText: t('Close'),
      });
    }
  }, [isContractDeclined, history, t]);

  // useEffect(() => {

  // },[form]);

  useEffect(() => {
    const fetchData = async () => {
      if (docuSignSignatureProcessId) {
        try {
          const response = await fetchDocumentFromDocuSign();
          if (response.status === 'COMPLETED') {
            setDocuSignDocument(response.file);
          } else if (response.status === 'DECLINED') {
            setContractDeclined(true);
          }
        } catch (error) {
          setDocuSignError(true);
        }
      }
    };

    void fetchData();
  }, [docuSignSignatureProcessId]);

  const readOnly = isReadOnly(applicationQuery.data, isItcardholderFlow);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    void applicationQuery.refetch();
  };

  const {
    isMultipleSignatories,
    selectedAuthorizedRepresentativeIndex,
    authorizedSignatoryEmail,
    setAuthorizedSignatoryEmail,
    resultingAuthorizedRepresentative,
  } = useAuthorizedSignatories();

  const currentUserEmail = getEmail();
  const isCurrentUserAuthorizedSignatory = authorizedSignatoryEmail === currentUserEmail;

  const handleGenerateClick = () => {
    generateContract();
  };

  const generateContract = () => {
    generateConsentMutation.mutate();
  };

  const handleClick = () => {
    setIsLoading(true);
  };

  const onFinish = async (values: { data: ImageResponse | ImageResponse[] }) => {
    try {
      if (Array.isArray(values.data)) {
        await uploadContractMutation.mutateAsync(values.data);
      } else {
        await uploadContractMutation.mutateAsync([values.data]);
      }
      // updateStepKey("completion"); // Change it to new step key
      // history.push(paths.cardHolder.completion);
      return true;
    } catch (error) {
      console.error('An error occurred while proceeding to the next step', error);
      setIsLoading(false);
      return false;
    }
  };

  // const onFileUploadFinish = (values: any) => {
  //   if(isOnboardingCompleted) {
  //     updateStepKey("completion");
  //     history.push(paths.cardHolder.completion);
  //   } else {
  //     setIsFormSubmitted(true);
  //   }
  // };

  const onFileUploadFinish = async () => {
    if (!isOnboardingCompleted) {
      const response = await saveCardHolderMutation.mutateAsync({
        ...cardHolderData,
        consent: form.getFieldsValue()?.consent,
      });
      updateCardHolderData(response, () => {
        updateStepKey('completion');
        history.push(paths.cardHolder.completion);
      });
    } else {
      history.push(paths.cardHolder.completion);
    }

    void getCardholderContactId(cardHolderData?.mobile, cardHolderData?.email).then((data: any) => {
      const [initialContact, ...rest] = data;
      contactMutation.mutate(
        contactObjCreation(
          { ...cardHolderData, contactId: initialContact?.contactId ?? undefined },
          { type: 'ADD', role: 'cardholder' },
        ),
      );
    });
  };

  const signatorySection = isMultipleSignatories && (
    <>
      <SignatorySection
        resultingAuthorizedRepresentative={
          resultingAuthorizedRepresentative && typeof resultingAuthorizedRepresentative !== 'string'
            ? resultingAuthorizedRepresentative
            : undefined
        }
        onOpen={handleOpen}
        readOnly={readOnly}
        authorizedSignatoryEmail={authorizedSignatoryEmail}
        isCurrentUserAuthorizedSignatory={isCurrentUserAuthorizedSignatory}
      />
    </>
  );

  const handleSignWithDocuSignClick = async () => {
    setSendingToDocuSign(true);
    try {
      const response: any = await signWithDocuSign();
      window.location.href = response.redirectUrl;
    } catch (error) {
      setDocuSignError(true);
    }
  };

  return (
    <>
      <Container>
        <Typography.Title>{t('cardholder.details.consent')}</Typography.Title>
        {docuSignDocument ? (
          <Section formItemLast>
            <Typography.Paragraph>{t('cardholder.details.consent.success')}</Typography.Paragraph>
            <Form
              name={location.pathname}
              onFinish={onFinish}
              initialValues={{
                data: docuSignDocument,
              }}
              disabled={isOnboardingCompleted}
            >
              <Form.Item name="data" rules={[{ required: true }]} hidden>
                <DocumentInput name="photos" variant="default" disabled={readOnly} />
              </Form.Item>
            </Form>
            <SaveSignedConsent value={docuSignDocument} />
          </Section>
        ) : isSignatureProcessInProgress ? (
          <>
            <DocumentsSharingProgressModal
              visible={!isDocuSignError}
              message={t('cardholder.details.consent.fetching')}
            />
            <Skeleton />
          </>
        ) : !generateConsentMutation.data ? (
          <Section formItemLast>
            {signatorySection}
            <Typography.Paragraph>{t('cardholder.details.consent.label')}</Typography.Paragraph>
            <Space direction="vertical" size={24}>
              <Button
                id="signContract_generateContract"
                extraLarge
                icon={<ContractGenerationIcon />}
                type="default"
                onClick={handleGenerateClick}
                loading={generateConsentMutation.isLoading || applicationQuery.isLoading}
                disabled={applicationQuery.isLoading || readOnly}
              >
                {t('cardholder.details.consent.generate')}
              </Button>
            </Space>
          </Section>
        ) : (
          <>
            <Section formItemLast>
              {signatorySection}
              <Typography.Title level={5}>{t('Download Consent')}</Typography.Title>
              <SaveConsent
                btnTitleName="Download Consent"
                name={generateConsentMutation.data.name}
                data={generateConsentMutation.data.blob}
                onClick={() => {
                  setShowSignConsent(true);
                }}
              />
            </Section>
            <Section>
              {isCurrentUserAuthorizedSignatory && (
                <>
                  <Typography.Title level={5}>{t('Sign and submit')}</Typography.Title>
                  <Space direction="vertical" size={24}>
                    <Button
                      id="signContract_signWithDocuSign"
                      extraLarge
                      onClick={handleSignWithDocuSignClick}
                      icon={<DocuSignLogoIcon />}
                      type="default"
                    >
                      {t('cardholder.details.consent.docusign')}
                    </Button>
                  </Space>
                  {isSendingToDocuSign && (
                    <DocumentsSharingProgressModal visible message={t('cardholder.details.consent.processing')} />
                  )}
                </>
              )}
            </Section>
          </>
        )}
        <Section>
          <Form
            name={location.pathname}
            onFinish={onFileUploadFinish}
            initialValues={{
              data: docuSignDocument,
            }}
            form={form}
            disabled={isOnboardingCompleted}
          >
            <Typography.Title level={5}>{t('Sign and upload consent below')}</Typography.Title>
            <Form.Item name={n(['files'])} rules={[{ required: true }]}>
              <DocumentInput name="document" variant="default" />
            </Form.Item>
          </Form>
        </Section>
      </Container>
    </>
  );
};

const n = buildNamePath('consent');

const Container = styled.div`
  h1 {
    margin-bottom: 16px;
  }
  .SignContract-Subtitle {
    margin-bottom: 24px;
  }
`;

export default NonUaePassSignConsent;
